import { render, staticRenderFns } from "./ClientAdministrationUsers.vue?vue&type=template&id=3659c072&scoped=true&"
import script from "./ClientAdministrationUsers.vue?vue&type=script&lang=ts&"
export * from "./ClientAdministrationUsers.vue?vue&type=script&lang=ts&"
import style0 from "./ClientAdministrationUsers.vue?vue&type=style&index=0&id=3659c072&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3659c072",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCol,VDivider,VIcon,VRow,VSpacer,VTextField})
